/**
 * Browser history use to navigate between pages.
 */
import { createBrowserHistory } from 'history';
export default createBrowserHistory()